/**
 * VIN (Vehicle Identification Number) validation
 *
 * Rules:
 * - Exactly 17 characters
 * - Only alphanumeric characters (A-Z, 0-9)
 * - Cannot contain I, O, Q letters (to avoid confusion with 1, 0)
 */

const VIN_LENGTH = 17;
const INVALID_CHARS = /[IOQ]/i;
const VALID_PATTERN = /^[A-HJ-NPR-Z0-9]+$/i;

export function isVinValid(vin?: string | null): boolean {
  if (!vin) return false;

  const clean = vin.trim().toUpperCase();

  // Must be exactly 17 characters
  if (clean.length !== VIN_LENGTH) return false;

  // Cannot contain I, O, Q
  if (INVALID_CHARS.test(clean)) return false;

  // Must be alphanumeric (excluding I, O, Q)
  if (!VALID_PATTERN.test(clean)) return false;

  return true;
}

export function getVinError(vin?: string | null): string | undefined {
  if (!vin) return undefined;

  const clean = vin.trim().toUpperCase();

  if (clean.length > VIN_LENGTH) {
    return `VIN broj ima previše znakova (max ${VIN_LENGTH})`;
  }

  if (INVALID_CHARS.test(clean)) {
    return "VIN broj ne smije sadržavati slova I, O ili Q";
  }

  if (clean.length === VIN_LENGTH && !VALID_PATTERN.test(clean)) {
    return "VIN broj smije sadržavati samo slova i brojeve";
  }

  return undefined;
}
